import Error404 from '@/components/global/Error404'
import Error403 from '@/components/global/Error403'
import ErrorOrgNotFound from '@/components/global/ErrorOrgNotFound'

export default [
    {
        path: '*',
        name: 'Error404',
        component: Error404
    },
    {
        path: '/x404/',
        name: 'ErrorOrgNotFound',
        component: ErrorOrgNotFound
    },
    {
        path: '/x403/',
        name: 'Error403',
        component: Error403
    }
  ]
